import { render, staticRenderFns } from "./FlowUsageStatistics.vue?vue&type=template&id=5fbc36c8&scoped=true&"
import script from "./FlowUsageStatistics.vue?vue&type=script&lang=js&"
export * from "./FlowUsageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FlowUsageStatistics.vue?vue&type=style&index=0&id=5fbc36c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc36c8",
  null
  
)

export default component.exports